export const pusherConfigSelector = state => state.pusher.config;

export default {};
